import { FETCH_BATCHES_FAILURE,FETCH_BATCHES_SUCCESS,FETCH_BATCHES_REQUEST } from "../actions/batchGroupActions";

const batchInitialState = {
    batches: [],
    loading: false,
    error: null,
  };
  
  const batchGroupReducer = (state = batchInitialState, action) => {
    switch (action.type) {
      case FETCH_BATCHES_REQUEST:
        return { ...state, loading: true };
      case FETCH_BATCHES_SUCCESS:
        return { ...state, loading: false, batches: action.payload };
      case FETCH_BATCHES_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default batchGroupReducer;
  